module.exports = __webpack_public_path__ + "img/renliancaiji_bg1.443b3206.png";